import { Context, CustomQuery } from '@vue-storefront/core';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default async function customCartNum({ client, config }: Context, parms: CustomQuery): Promise<any> {
  const url = new URL('/mall/cart/num', config.api.url);

  // // Add parameters passed from composable as query strings to the URL
  // url.searchParams.set('password', password);

  // Use axios to send a GET request
  const { data } = await client.post(url.href);

  // Return data from the API
  return data;
}
